import { useGetApiV1Serie } from '@/shared/api/generated';
import { SERIE_COMPANY_FILTER_TYPE, type SerieFilters } from '../types/serieFilters';

/** Itens por página da listagem de Séries (paginação server-side). */
export const SERIE_PAGE_SIZE = 20;

/**
 * Hook para listar Séries com busca e paginação **server-side**.
 *
 * Envolve o hook gerado pelo Kubb para `GET /api/v1/serie`.
 *
 * @param filters - Filtros de busca/paginação atuais
 * @returns Página de séries com estado de loading/error e os totais retornados pela API
 *
 * @example
 * ```tsx
 * const { series, totalCount, totalPages, isLoading } = useSerieList(filters);
 * ```
 */
export function useSerieList(filters: SerieFilters) {
  const query = useGetApiV1Serie({
    ...(filters.search ? { search: filters.search } : {}),
    filter: filters.filter,
    ...(filters.filter === SERIE_COMPANY_FILTER_TYPE.Company && filters.companyId
      ? { companyId: filters.companyId }
      : {}),
    page: filters.page,
    pageSize: SERIE_PAGE_SIZE,
  });

  return {
    series: query.data?.data ?? [],
    totalCount: query.data?.totalCount ?? 0,
    totalPages: query.data?.totalPages ?? 1,
    currentPage: query.data?.currentPage ?? filters.page,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
  } as const;
}
